import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// Zdieľané počítadlo zateplených m²: 350 000 základ + reálne m² z referencií (naše aj partnerské).
// Načíta sa raz na session (cache), pri výpadku API sa zobrazí základ.
const BASE_M2 = 350000;
let cached = null;
let inflight = null;

export const fmtM2 = (n) => String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, " ");

export function useM2() {
  const [m2, setM2] = useState(cached ?? BASE_M2);
  useEffect(() => {
    if (cached) { setM2(cached); return; }
    if (!inflight) {
      inflight = api.get("/references/stats")
        .then((r) => { cached = r.data?.total_m2 || BASE_M2; })
        .catch(() => { cached = BASE_M2; });
    }
    inflight.then(() => setM2(cached)).finally(() => { inflight = null; });
  }, []);
  return m2;
}
